import { render, staticRenderFns } from "./TabsHeader.vue?vue&type=template&id=56966688&scoped=true&"
import script from "./TabsHeader.vue?vue&type=script&lang=ts&"
export * from "./TabsHeader.vue?vue&type=script&lang=ts&"
import style0 from "./TabsHeader.vue?vue&type=style&index=0&id=56966688&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56966688",
  null
  
)

export default component.exports